import { render, staticRenderFns } from "./SupplementEdit.vue?vue&type=template&id=8e59d710&scoped=true&"
import script from "./SupplementEdit.vue?vue&type=script&lang=js&"
export * from "./SupplementEdit.vue?vue&type=script&lang=js&"
import style0 from "./SupplementEdit.vue?vue&type=style&index=0&id=8e59d710&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e59d710",
  null
  
)

export default component.exports